import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import Logo from '../images/de-graaff-logo-kleur.svg'
import external from '../images/external.png'

export default class Header extends React.Component {
  render() {
    let isActive = false
    if (typeof window !== 'undefined') {
      isActive = window.location.pathname.indexOf('nieuws') > -1
    }

    return (
      <div>
        <div className="Header">
          <div className="inner">
            <div className="Header-left">
              <img
                className="Header-logo"
                src={Logo}
                alt="De Graaff Financieel Advies"
              />
            </div>
            <div className="Header-right">
              <p className="Header-p">
                <span className="phone">0252 – 22 25 25</span>
                <span className="divider">|</span>
                <span className="email">info@DeGraaffFinancieeladvies.nl</span>
              </p>
            </div>
          </div>
        </div>
        <div className="Nav">
          <div className="inner">
            <nav>
              <Link exact activeClassName="active" to="/">
                Home
              </Link>
              <a href="/nieuws/" className={isActive ? 'active' : null}>
                Nieuws
              </a>
              <a
                href="https://degraafffinancieeladvies.mijndigimap.nl/"
                target="_blank"
                rel="noopener nofollow"
              >
                Klantportaal<img height={12} src={external} aria-hidden />
              </a>
            </nav>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Header.js